import React from "react";
import Logo from "../Logo/Logo";
import Nav from "../Nav/Nav";
import Friends from "./Friends/Friends";
import s from './Sidebar.module.scss'

const Sidebar = (props) => {
  return (
    <div className={s.sidebar}>
      <Logo />
      <Nav />
      <Friends state={props.state.friends} />
    </div>
  );
}

export default Sidebar;